import React from "react";
import Head from "next/head";
import HeroSection from "../../components/about/HeroSection";
import PurposeSection from "../../components/about/PurposeSection";
import Team from "../../components/about/Team";
import TechStack from "../../components/about/tech-stack";

const About = () => {
  return (
    <>
      <Head>
        <title>About || Impactoverse</title>
        <meta
          name="description"
          content="Impactoverse - A space to easily launch meaningful campaigns, back vetted causes, grow community, and build connections that scale impact."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.png" />
      </Head>

      <div className="flex flex-col min-h-screen bg-transparent dark:bg-transparent">
        <main className="flex-grow">
          <HeroSection />
          <PurposeSection />
          <Team />
          <TechStack />
        </main>
      </div>
    </>
  );
};

export default About;
